import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtilsV2 } from '@shared/utils';
import { RequestStrategyEnum, TransferRequestsApi, type WithSignal, type FeeRequest } from '@shared/api';

const getFeeEffect = createEffect(({ signal, ...request }: WithSignal<FeeRequest>) => TransferRequestsApi.getFee(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<number | null>(null)
  .on(getFeeEffect.done, (_, data) => data.result.data ?? 0)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getFeeEffect.pending, (_, data) => data)
  .on(getFeeEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getFeeEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getFeeEffect, () => null)
  // .on(getFeeEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getFeeEffect.fail, (_, data) =>
    ApiUtilsV2.abortApiErrorFailCaseTrigger(data.error, 'Something went wrong while fetching Fee. Please try again.'),
  )
  .on(getFeeEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

const getFeeApi = ApiUtilsV2.wrapperApi(getFeeEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getFeeApi.cancel());

export const $transferRequestsFeeStore = {
  events: {
    getFee: getFeeApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
